const hostnameToEnvKey: Record<string, string> = {
  'portal-dev.sitecore-staging.cloud': 'dev',
  'portal-qa.sitecore-staging.cloud': 'qa',
  'portal-staging.sitecore-staging.cloud': 'staging',
  'portal-preprod.sitecorecloud.io': 'preprod',
  'portal-beta.sitecorecloud.io': 'preprod',
  'portal.sitecorecloud.io': 'prod',
};

const DEFAULT_ENV_KEY = 'staging';

export const getEnvironmentFromUrl = (): string => {
  const currentHostname = window.location.hostname;
  return hostnameToEnvKey[currentHostname] || DEFAULT_ENV_KEY;
};

const hostnameToDeployUrl: Record<string, string> = {
  'portal-dev.sitecore-staging.cloud':
    'https://deploy-dev.sitecore-staging.cloud',
  'portal-qa.sitecore-staging.cloud':
    'https://deploy-qa.sitecore-staging.cloud',
  'portal-staging.sitecore-staging.cloud':
    'https://deploy-staging.sitecore-staging.cloud',
  'portal-preprod.sitecorecloud.io': 'https://deploy-preprod.sitecorecloud.io',
  'portal-beta.sitecorecloud.io': 'https://deploy-preprod.sitecorecloud.io',
  'portal.sitecorecloud.io': 'https://deploy.sitecorecloud.io',
};
const DEFAULT_DEPLOY_URL = 'https://deploy-staging.sitecore-staging.cloud';

export const getDeployBaseUrl = (): string => {
  const currentHostname = window.location.hostname;
  return hostnameToDeployUrl[currentHostname] || DEFAULT_DEPLOY_URL;
};

/**
 * Maps portal environment keys to Inventory API Environment label values.
 * This mapping is needed because the Inventory API uses different label values
 * than the portal's internal environment keys.
 *
 * @param portalEnv - The portal environment key (from envConfig or getEnvironmentFromUrl)
 * @returns The corresponding Inventory API Environment label value
 *
 * @example
 * getInventoryEnvironmentLabel('dev') => 'dev'
 * getInventoryEnvironmentLabel('qa') => 'qa'
 * getInventoryEnvironmentLabel('staging') => 'staging'
 * getInventoryEnvironmentLabel('preprod') => 'pre-production'
 * getInventoryEnvironmentLabel('prod') => 'production'
 */
export const getInventoryEnvironmentLabel = (portalEnv: string): string => {
  const inventoryLabelMap: Record<string, string> = {
    dev: 'dev',
    qa: 'qa',
    staging: 'staging',
    preprod: 'pre-production',
    prod: 'production',
    production: 'production', // Handle case where backend already returns 'production'
    'pre-production': 'pre-production', // Handle case where backend already returns 'pre-production'
  };

  const normalizedEnv = portalEnv.toLowerCase();
  return inventoryLabelMap[normalizedEnv] || normalizedEnv;
};
